import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useMe, useUpdateAccount } from "@/hooks/use-auth";

import { profileSchema, profileInitial, type ProfileValues } from "./schema";

export function ProfileForm() {
  const { data: user, isLoading } = useMe();
  const { mutateAsync: updateAccount, isPending } = useUpdateAccount();

  const form = useForm<ProfileValues>({
    resolver: zodResolver(profileSchema),
    defaultValues: profileInitial,
  });

  useEffect(() => {
    if (user) {
      form.reset({
        name: user.name,
        email: user.email,
      });
    }
  }, [user, form]);

  async function onSubmit(values: ProfileValues) {
    try {
      await updateAccount({
        name: values.name,
        email: values.email,
      });
      toast.success("Profil akun berhasil diperbarui.");
    } catch {
      toast.error("Gagal memperbarui profil akun.");
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Informasi Akun</CardTitle>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="grid grid-cols-1 gap-5 sm:grid-cols-2"
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nama</FormLabel>
                  <FormControl>
                    <Input disabled={isLoading || isPending} {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input
                      type="email"
                      disabled={isLoading || isPending}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="sm:col-span-2 flex justify-end">
              <Button type="submit" disabled={isLoading || isPending}>
                {isPending ? "Menyimpan..." : "Simpan"}
              </Button>
            </div>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
}
